import { useMutation } from "urql";

import { UpdateAiPromptDocument } from "../../../../graphql/generated.ts";

export function useUpdateAIPrompt() {
  return useMutation(UpdateAiPromptDocument);
}
